document.addEventListener('DOMContentLoaded', function () {
  const builders = document.querySelectorAll('.mk-deal-builder__body');

  initAnimatedReveal();
  initBundleCartGuard();

  if (!builders.length) return;

  builders.forEach(initDealBuilder);

  function initDealBuilder(builder) {
    const wrap = builder.closest('.mk-deal-builder');
    if (!wrap) return;

    const cards = wrap.querySelectorAll('[data-deal-card]');
    const productCards = wrap.querySelectorAll('[data-product-card]');
    const addBtn = wrap.querySelector('[data-add-deal-btn]');
    const mobileAddBtn = wrap.querySelector('[data-mobile-add-btn]');
    const msgBox = wrap.querySelector('[data-deal-msg]');
    const pickedList = wrap.querySelector('[data-picked-list]');
    const subtotalEl = wrap.querySelector('[data-summary-subtotal]');
    const savingEl = wrap.querySelector('[data-summary-saving]');
    const totalEl = wrap.querySelector('[data-summary-total]');
    const totalMobileEl = wrap.querySelector('[data-summary-total-mobile]');
    const dealEl = wrap.querySelector('[data-summary-deal]');
    const selectedCountEl = wrap.querySelector('[data-selected-count]');
    const selectedCountMobileEl = wrap.querySelector('[data-selected-count-mobile]');
    const progressFillEl = wrap.querySelector('[data-progress-fill]');
    const progressTextEl = wrap.querySelector('[data-progress-text]');

    let activeDeal = getDealFromCard(wrap.querySelector('[data-deal-card].is-active'));
    let selectedItems = [];

    updateDealSummary();
    updateCardsAvailability();
    bindDealCards();
    bindProducts();

    if (addBtn) addBtn.addEventListener('click', addCompleteDealToCart);
    if (mobileAddBtn) mobileAddBtn.addEventListener('click', addCompleteDealToCart);

    function bindDealCards() {
      cards.forEach(card => {
        card.addEventListener('click', function () {
          cards.forEach(c => c.classList.remove('is-active'));
          card.classList.add('is-active');

          activeDeal = getDealFromCard(card);
          selectedItems = [];

          productCards.forEach(pc => {
            pc.classList.remove('is-selected', 'is-disabled');
            const btn = pc.querySelector('[data-pick-btn]');
            if (btn) {
              btn.textContent = 'Select';
              btn.disabled = false;
            }
          });

          clearMessage();
          updateDealSummary();
          updateCardsAvailability();
        });
      });
    }

    function bindProducts() {
      productCards.forEach(card => {
        const btn = card.querySelector('[data-pick-btn]');
        const variantSelect = card.querySelector('[data-variant-select]');

        if (variantSelect) {
          variantSelect.addEventListener('change', function () {
            const previousVariantId = String(card.dataset.variantId || '');
            const newVariantId = String(variantSelect.value || '');
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];

            card.dataset.variantId = newVariantId;

            if (selectedOption) {
              card.dataset.price = selectedOption.dataset.price || card.dataset.price;
            }

            const existingIndex = selectedItems.findIndex(item => item.variantId === previousVariantId);
            if (existingIndex > -1) {
              selectedItems[existingIndex].variantId = newVariantId;
              selectedItems[existingIndex].price = parseInt(card.dataset.price || '0', 10);
              selectedItems[existingIndex].title = getCardTitle(card);
            }

            updateDealSummary();
            updateCardsAvailability();
          });
        }

        if (btn) {
          btn.addEventListener('click', function () {
            if (card.classList.contains('is-disabled') && !card.classList.contains('is-selected')) return;
            toggleProduct(card);
          });
        }
      });
    }

    function toggleProduct(card) {
      const variantId = String(card.dataset.variantId || '');
      const title = getCardTitle(card);
      const price = parseInt(card.dataset.price || '0', 10);

      if (!variantId) {
        setMessage('This product variant is not available.', 'error');
        return;
      }

      const foundIndex = selectedItems.findIndex(item => item.variantId === variantId);

      if (foundIndex > -1) {
        selectedItems.splice(foundIndex, 1);
        card.classList.remove('is-selected');
      } else {
        if (selectedItems.length >= activeDeal.requiredQty) {
          setMessage(`You can only pick ${activeDeal.requiredQty} items for this deal.`, 'error');
          updateCardsAvailability();
          return;
        }

        selectedItems.push({
          variantId,
          title,
          price
        });

        card.classList.add('is-selected');
      }

      clearMessage();
      updateDealSummary();
      updateCardsAvailability();
    }

    function updateDealSummary() {
      const selectedCount = selectedItems.length;
      const requiredCount = activeDeal.requiredQty;
      const subtotal = selectedItems.reduce((sum, item) => sum + item.price, 0);
      const saving = Math.round(subtotal * (activeDeal.discountPercent / 100));
      const total = subtotal - saving;
      const progressPercent = requiredCount > 0 ? Math.min((selectedCount / requiredCount) * 100, 100) : 0;

      if (dealEl) dealEl.textContent = activeDeal.title || '—';
      if (selectedCountEl) selectedCountEl.textContent = `${selectedCount}/${requiredCount}`;
      if (selectedCountMobileEl) selectedCountMobileEl.textContent = `${selectedCount}/${requiredCount} selected`;

      if (progressFillEl) {
        progressFillEl.style.width = `${progressPercent}%`;
      }

      if (progressTextEl) {
        if (selectedCount === 0) {
          progressTextEl.textContent = `Select ${requiredCount} item${requiredCount > 1 ? 's' : ''} to unlock ${activeDeal.discountPercent}% OFF.`;
        } else if (selectedCount < requiredCount) {
          const left = requiredCount - selectedCount;
          progressTextEl.textContent = `Pick ${left} more item${left > 1 ? 's' : ''} to unlock ${activeDeal.discountPercent}% OFF.`;
        } else {
          progressTextEl.textContent = `${activeDeal.discountPercent}% OFF unlocked. Your deal is ready.`;
        }
      }

      if (pickedList) {
        if (!selectedItems.length) {
          pickedList.innerHTML = 'No products selected yet.';
        } else {
          pickedList.innerHTML = selectedItems.map((item, i) => {
            return `<div class="mk-picked-item">${i + 1}. ${escapeHtml(item.title)}</div>`;
          }).join('');
        }
      }

      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal, builder.dataset.moneyFormat);
      if (savingEl) savingEl.textContent = '-' + formatMoney(saving, builder.dataset.moneyFormat);
      if (totalEl) totalEl.textContent = formatMoney(total, builder.dataset.moneyFormat);
      if (totalMobileEl) totalMobileEl.textContent = formatMoney(total, builder.dataset.moneyFormat);

      updateAddButtons(selectedCount === requiredCount);
    }

    function updateAddButtons(isReady) {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.classList.toggle('is-ready', isReady);
        addBtn.textContent = isReady ? 'Add Complete Deal' : `Select ${activeDeal.requiredQty} Items`;
      }

      if (mobileAddBtn) {
        mobileAddBtn.disabled = false;
        mobileAddBtn.classList.toggle('is-ready', isReady);
        mobileAddBtn.textContent = isReady ? 'Add Deal' : `Pick ${activeDeal.requiredQty}`;
      }
    }

    function updateCardsAvailability() {
      const isFull = selectedItems.length >= activeDeal.requiredQty;

      productCards.forEach(card => {
        const btn = card.querySelector('[data-pick-btn]');
        const isSelected = card.classList.contains('is-selected');

        card.classList.remove('is-disabled');
        if (btn) btn.disabled = false;

        if (isSelected) {
          if (btn) btn.textContent = 'Selected';
          return;
        }

        if (isFull) {
          card.classList.add('is-disabled');
          if (btn) {
            btn.textContent = 'Deal Full';
            btn.disabled = true;
          }
        } else {
          if (btn) btn.textContent = 'Select';
        }
      });
    }

    async function addCompleteDealToCart() {
      clearMessage();

      if (selectedItems.length !== activeDeal.requiredQty) {
        setMessage(`Please select exactly ${activeDeal.requiredQty} items for this deal.`, 'error');
        return;
      }

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
      }

      if (mobileAddBtn) {
        mobileAddBtn.disabled = true;
        mobileAddBtn.textContent = 'Adding...';
      }

      const groupId = 'grp_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);

      const items = selectedItems.map(item => ({
        id: Number(item.variantId),
        quantity: 1,
        properties: {
  "Deal Label": activeDeal.label,
  "Deal Title": activeDeal.title,
  _deal_name: activeDeal.label,
  _deal_title: activeDeal.title,
  _deal_group: groupId,
  _deal_required: String(activeDeal.requiredQty),
  _deal_percent: String(activeDeal.discountPercent)
}
      }));

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Could not add deal to cart');
        }

        setMessage('Deal added successfully.', 'success');

        setTimeout(() => {
          window.location.href = '/cart';
        }, 450);
      } catch (error) {
        setMessage('There was a problem adding the deal. Please try again.', 'error');
        updateAddButtons(true);
      }
    }

    function getDealFromCard(card) {
      if (!card) {
        return {
          title: 'Deal',
          label: 'BUY2DEAL',
          requiredQty: 2,
          discountPercent: 25
        };
      }

      return {
        title: card.dataset.title || 'Deal',
        label: card.dataset.label || 'BUY2DEAL',
        requiredQty: parseInt(card.dataset.required || '2', 10),
        discountPercent: parseInt(card.dataset.percent || '0', 10)
      };
    }

    function getCardTitle(card) {
      const titleEl = card.querySelector('.mk-deal-product__title');
      const variantSelect = card.querySelector('[data-variant-select]');

      let title = titleEl ? titleEl.textContent.trim() : String(card.dataset.title || '').trim();

      if (variantSelect && variantSelect.selectedIndex > -1) {
        const variantText = variantSelect.options[variantSelect.selectedIndex].textContent.trim();
        if (variantText && !/default title/i.test(variantText)) {
          title += ` — ${variantText}`;
        }
      }

      return title;
    }

    function setMessage(text, type) {
      if (!msgBox) return;
      msgBox.textContent = text;
      msgBox.classList.remove('is-error', 'is-success');
      if (type === 'error') msgBox.classList.add('is-error');
      if (type === 'success') msgBox.classList.add('is-success');
    }

    function clearMessage() {
      if (!msgBox) return;
      msgBox.textContent = '';
      msgBox.classList.remove('is-error', 'is-success');
    }
  }

  function initBundleCartGuard() {
    if (!window.location.pathname.includes('/cart')) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const grouped = {};

        (cart.items || []).forEach(item => {
          const props = item.properties || {};
          const dealGroup = props._deal_group;
          const required = parseInt(props._deal_required || '0', 10);

          if (!dealGroup) return;

          if (!grouped[dealGroup]) {
            grouped[dealGroup] = {
              required,
              items: []
            };
          }

          grouped[dealGroup].items.push(item);
        });

        const updates = {};

        Object.keys(grouped).forEach(groupId => {
          const group = grouped[groupId];
          if (group.required > 0 && group.items.length !== group.required) {
            group.items.forEach(item => {
              updates[item.key] = 0;
            });
          }
        });

        if (Object.keys(updates).length) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
          }).then(() => {
            window.location.reload();
          });
        }
      })
      .catch(() => {});
  }

  function initAnimatedReveal() {
    const animatedItems = document.querySelectorAll('.mk-deal-builder--animated .mk-animate');
    if (!animatedItems.length) return;

    // Immediate fallback so nothing stays hidden
    const forceVisibleTimeout = window.setTimeout(() => {
      animatedItems.forEach(el => el.classList.add('is-visible'));
    }, 1200);

    if (!('IntersectionObserver' in window)) {
      animatedItems.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.01,
      rootMargin: '200px 0px 200px 0px'
    });

    requestAnimationFrame(() => {
      animatedItems.forEach(el => observer.observe(el));
    });

    window.addEventListener('load', function () {
      window.clearTimeout(forceVisibleTimeout);
      animatedItems.forEach(el => el.classList.add('is-visible'));
    }, { once: true });
  }

  function formatMoney(cents, moneyFormat) {
    let value = (cents / 100).toFixed(2);

    if (moneyFormat && moneyFormat.indexOf('amount_no_decimals') > -1) {
      value = Math.round(cents / 100).toString();
    }

    return moneyFormat
      ? moneyFormat.replace(/\{\{\s*amount(?:_no_decimals)?\s*\}\}/, value)
      : value;
  }

  function escapeHtml(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
});